<script setup lang="ts">
import { useTranslation } from 'i18next-vue';
import { computed } from 'vue';
import { HistoryPropertyChange } from '@/api/generator';
import { I18nKey } from '@/utils/typings';

interface HistoryPropertyProps {
  isOldItem?: boolean;
  change: HistoryPropertyChange;
}

const historyProp = computed(() => {
  const valueToShow = props.isOldItem ? props.change.originalValue : props.change.newValue;
  return valueToShow && props.change.isLocalizable ? t(valueToShow as I18nKey) : valueToShow;
});

const props = defineProps<HistoryPropertyProps>();

const { t } = useTranslation();

const value = computed(() => (historyProp.value ? historyProp.value : t('None')));
</script>

<template>
  <div
    class="text-body-2 history-prop-text"
    :class="{ 'new-item': !isOldItem, 'old-item': isOldItem }"
  >
    {{ value }}
  </div>
</template>

<style lang="scss" scoped>
.new-item {
  font-size: 18px;
  font-weight: 500;
  white-space: pre-line;
}
.old-item {
  text-decoration: line-through;
  color: rgb(var(--v-theme-primary-lighten-1));
}
</style>
